if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart && !p80.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (window.cartType === 'p80' && p80 && p80.cart) {
                      p80.cart.toggleCart();
                    } else {
                      this.cart.renderContents(response);
                    }
                  });
                },
                {once: true}
              );
              quickAddModal.hide(true);
            } else {
              if (window.cartType === 'p80' && p80 && p80.cart) {
                p80.cart.toggleCart();
              } else {
                this.cart.renderContents(response);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );

  class CustomWord extends HTMLElement {
    constructor() {
      super();
      this.id = this.hasAttribute('data-id') ? this.getAttribute('data-id') : null;

      this.input = this.querySelector('input');
      this.charCounter = this.querySelector('[data-letter-count]');

      this.inputProperty = document.querySelectorAll(`[data-custom-prop-id='${this.id}']`);
      this.timeStampProperty = document.querySelectorAll(`[data-timestamp-id='${this.id}']`);

      this.outputEl = document.querySelector(`.custom-word-${this.id}`);

      this.addToCartButtons = document.querySelectorAll(`[type="submit"].product-form__submit-${this.id}`);

      if (this.input) {
        this.maxNumOfChar = this.input.getAttribute('maxlength')
          ? parseInt(this.input.getAttribute('maxlength'), 10)
          : 9;

        this.input.addEventListener(
          'input',
          debounce((event) => {
            this.countCharacter();
          }, 100).bind(this)
        );
      }
    }

    countCharacter(event) {
      let numOfEnteredChar = this.input.value.length;
      let counter = this.maxNumOfChar - numOfEnteredChar;
      let inputValue = this.input.value;

      if (this.charCounter) this.charCounter.textContent = counter;

      if (inputValue.trim().length !== 0) {
        this.outputEl.textContent = ': ' + inputValue.toUpperCase();

        this.addToCartButtons.forEach((elem) => {
          elem.removeAttribute('disabled');
        });

        this.timeStampProperty.forEach((elem) => {
          elem.value = Date.now();
        });
      } else {
        this.outputEl.textContent = inputValue.toUpperCase();

        this.addToCartButtons.forEach((elem) => {
          elem.setAttribute('disabled', 'disabled');
        });
        this.timeStampProperty.forEach((elem) => {
          elem.value = null;
        });
      }
      this.inputProperty.forEach((elem) => {
        elem.value = inputValue.toUpperCase();
      });
    }
  }

  customElements.define('custom-word', CustomWord);

  class CustomWordLip extends HTMLElement {
    constructor() {
      super();
      this.inputPropEl = document.querySelectorAll(`[data-custom-prop-id='${this.dataset.id}']`);
      this.timeStampEl = document.querySelectorAll(`[data-timestamp-id='${this.dataset.id}']`);
      this.addToCartButtons = document.querySelectorAll(`[type="submit"].product-form__submit-${this.dataset.id}`);
      this.selectedValue = null;

      this.addEventListener('change', this.onCustomWordChange);

      setTimeout(() => {
        this.updateImage();
      }, 150);
    }

    getSelectedValue() {
      if (this.querySelector(`input[data-custom-lip-${this.dataset.id}`) != null) {
        this.selectedValue = this.querySelector(`[data-custom-lip-${this.dataset.id}]:checked`).value;
      } else {
        this.selectedValue = this.querySelector(`select[data-custom-lip-${this.dataset.id}]`).value;

        document.querySelector(
          `input[data-custom-lip-${this.dataset.id}][value="${this.selectedValue}"]`
        ).checked = true;
      }

      return this.selectedValue;
    }

    onCustomWordChange() {
      this.selectedValue = this.getSelectedValue();
      this.currentColor = this.getSelectedColor().toLowerCase();

      const selectedColor = this.currentColor
        .split('custom')[0]
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/-$/, '')
        .replace(/^-/, '');
      const tempActiveEl = document.querySelector(
        `variant-radios[data-productid='${this.dataset.id}'] label[data-color-label-${selectedColor}]`
      );

      if (this.selectedValue != null)
        VariantSelects.prototype.toggleCustomWordBox(this.selectedValue.toLowerCase(), true, this.dataset.id);

      if (this.selectedValue != 'CUSTOM') {
        this.inputPropEl.forEach((elem) => {
          elem.value = this.selectedValue;
        });

        this.timeStampEl.forEach((elem) => {
          elem.value = Date.now();
        });

        this.addToCartButtons.forEach((elem) => {
          elem.removeAttribute('disabled');
        });

        /* Non 'CUSTOM' word options: If selected color option contains 'custom' such as 'gold custom',
         *  extract and set the color value as the selected option
         */

        if (this.currentColor.includes('custom')) {
          const selectedEl = tempActiveEl;
          if (selectedEl) {
            selectedEl.closest('variant-radios').removeAttribute('data-custom-word');
            selectedEl.click();
          }
          if (tempActiveEl) {
            tempActiveEl.classList.remove('active');
          }
        }
      } else {
        /* If this.selectedValue (word) is equal to CUSTOM,
         * then set the color option with the value '{selectedColor}-custom' as the selected option.
         * But set the {selectedColor} as active.
         */
        const selectedCustomEl = document.querySelector(
          `variant-radios[data-productid='${this.dataset.id}'] label[data-color-label-${selectedColor}-custom]`
        );

        if (selectedCustomEl) {
          selectedCustomEl.closest('variant-radios').setAttribute('data-custom-word', true);
          selectedCustomEl.click();
          if (tempActiveEl) {
            tempActiveEl.classList.add('active');
          }
        }
      }

      this.updateImage();
    }

    getSelectedColor() {
      const colourOptions = document.querySelector(
        `variant-radios[data-productid='${this.dataset.id}'] fieldset[data-swatches]`
      );

      if (!colourOptions) return;
      const inputs = Array.from(colourOptions.querySelectorAll('input'));
      return inputs.find((radio) => radio.checked).value;
    }

    updateImage() {
      const currentColor = this.getSelectedColor().toLowerCase();

      this.selectedVariantLip = document.querySelector(`input[data-custom-lip-${this.dataset.id}]:checked`);

      if (this.selectedVariantLip) {
        const selectedValues = currentColor + '/' + this.selectedVariantLip.value.toLowerCase();

        const glideGalleries = document.querySelectorAll(
          `[data-id=${this.dataset.section}-main-carousel], [data-id=${this.dataset.section}-secondary-carousel]`
        );

        glideGalleries.forEach((gallery) => {
          if (gallery.glide) {
            const slides = Array.from(gallery.querySelectorAll('li'));
            const activeSlide = gallery.querySelector('[data-image-alt="' + selectedValues + '"]');

            if (activeSlide) {
              const index = slides.indexOf(activeSlide);
              gallery.glide.go(`=${index}`);
            }
          }
        });
      }
    }
  }
  customElements.define('custom-word-lip', CustomWordLip);

  class ProductGiftNote extends HTMLElement {
    constructor() {
      super();
      this.formId = this.hasAttribute('data-form-id') ? this.getAttribute('data-form-id') : null;
      this.productForm = document.querySelector(`#${this.formId}`);
      this.checkbox = this.querySelector('[data-checkbox]');

      if (!this.checkbox) return;

      this.checkbox.addEventListener('change', this.giftNoteHandler.bind(this));

      this.noteInputs = document.querySelectorAll('[data-gift-note]');
      if (!this.noteInputs.length) return;

      this.charCounter = this.querySelector('[data-letter-count]');
      this.textArea = this.querySelector('[data-message]');
      this.maxNumOfChar = this.textArea.getAttribute('maxlength')
        ? parseInt(this.textArea.getAttribute('maxlength'), 10)
        : 160;

      const inputPropTo = document.createElement('input');
      inputPropTo.setAttribute('type', 'hidden');
      inputPropTo.classList.add('input-gift-note--to');
      this.productForm.appendChild(inputPropTo);

      const inputPropFrom = document.createElement('input');
      inputPropFrom.setAttribute('type', 'hidden');
      inputPropFrom.classList.add('input-gift-note--from');
      this.productForm.appendChild(inputPropFrom);

      const inputPropMsg = document.createElement('input');
      inputPropMsg.setAttribute('type', 'hidden');
      inputPropMsg.classList.add('input-gift-note--message');
      this.productForm.appendChild(inputPropMsg);

      this.noteInputs.forEach((noteInput) => {
        noteInput.addEventListener(
          'input',
          debounce((event) => {
            this.onInputChange(noteInput);
          }, 300).bind(this)
        );
      });
    }

    onInputChange(input) {
      const inputValue = input.value;
      const className = input.getAttribute('data-name');
      const inputPropName = input.getAttribute('data-label');
      const inputPropEl = this.productForm.querySelector(`.${className}`);

      if (!inputPropEl) return;
      inputPropEl.value = inputValue;

      if (input.tagName == 'TEXTAREA') {
        this.countCharacter(input);
      }

      if (inputValue != '' && !inputPropEl.hasAttribute('name')) {
        inputPropEl.setAttribute('name', 'properties[' + inputPropName + ']');
      } else if (inputValue == '' && inputPropEl.hasAttribute('name')) {
        inputPropEl.removeAttribute('name');
      }
    }

    giftNoteHandler(event) {
      if (!this.checkbox.checked) {
        const noteInputs = document.querySelectorAll('[data-gift-note]');
        noteInputs.forEach((noteInput) => {
          noteInput.value = '';
          noteInput.dispatchEvent(new Event('input', {bubbles: true}));
        });
      }
    }

    countCharacter(input) {
      let numOfEnteredChar = input.value.length;
      let counter = this.maxNumOfChar - numOfEnteredChar;
      let inputValue = this.textArea;

      if (this.charCounter) this.charCounter.textContent = counter;
    }
  }
  customElements.define('product-gift-note', ProductGiftNote);
}
